import { render, staticRenderFns } from "./ReviewPayment.vue?vue&type=template&id=a61c494e"
import script from "./ReviewPayment.vue?vue&type=script&lang=ts"
export * from "./ReviewPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports